import CRUDActions from './CRUD';
import Competition from '../api/competition';
import { AwsVideo } from "../api/videoAws"
import { VideoModel } from "../api/video"

class CompetitionCRUDActions extends CRUDActions {
  prefix = 'competition';

  get _model() {
    return Competition;
  }

  _createCompetitionModel(data) {
    return new Competition(data);
  }


  /**
   * save data to state. Using assign to object is bad practice.
   *
   * @param ActiveRecord model
   * @returns {Function}
   */
   save(model, data) {
    return async(dispatch) => {
      try {
        dispatch({
          type: this.saveItemAction
        });

        if (data.video instanceof VideoModel) {
          data.video = await AwsVideo.uploadVideo(data.video);
        }
        await model.save(data);

        dispatch({
          type: this.saveItemFinishedSuccessAction,
          model
        });

        return model;
      }

      catch (error) {
        dispatch({
          type: this.saveItemFinishedFailAction,
          error
        });

        throw error;
      }
    };
  }
}

export default new CompetitionCRUDActions();



// WEBPACK FOOTER //
// ./src/actions/competition.ts